const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ?? "";

/**
 * Turn API-relative paths into absolute URLs for <img src>, <a href>, etc.
 * Staging frontends are often on a different origin than the API; relative paths
 * would hit the static host instead of VITE_API_BASE_URL.
 */
export function toAbsoluteApiUrl(url: string | null | undefined): string | null {
  if (url === undefined || url === null || typeof url !== "string") {
    return null;
  }
  const u = url.trim();
  if (!u) {
    return null;
  }
  if (u.startsWith("blob:") || u.startsWith("data:")) {
    return u;
  }
  if (u.startsWith("http://") || u.startsWith("https://")) {
    // Do not force HTTPS for local development
    if (u.startsWith("http://localhost") || u.startsWith("http://127.0.0.1")) {
      return u;
    }
    return u.startsWith("http://") ? u.replace("http://", "https://") : u;
  }
  if (u.startsWith("//")) {
    return `https:${u}`;
  }
  if (!API_BASE_URL) {
    return u.startsWith("/") ? u : `/${u}`;
  }
  return u.startsWith("/") ? `${API_BASE_URL}${u}` : `${API_BASE_URL}/${u}`;
}

/** File-utility GET responses are sometimes wrapped in { data } / { result }. */
export function unwrapFileApiRecord(res: unknown): unknown {
  if (res === undefined || res === null || typeof res !== "object") {
    return res;
  }
  const r = res as Record<string, unknown>;
  if (
    r.data !== undefined &&
    r.data !== null &&
    typeof r.data === "object" &&
    !Array.isArray(r.data)
  ) {
    return r.data;
  }
  if (
    r.result !== undefined &&
    r.result !== null &&
    typeof r.result === "object" &&
    !Array.isArray(r.result)
  ) {
    return r.result;
  }
  return res;
}
